export function createAuthBearerToken(token: string): string
export function createAuthBearerToken(token: null | undefined): undefined
export function createAuthBearerToken(token: string | null | undefined) {
  return token ? `Bearer ${token}` : undefined
}
